import { Box, styled, useMediaQuery, useTheme } from "@mui/material";
import { BoxProps } from "@mui/system";
import BackgroundImage from "../assets/img/vessel_sunset.jpg";
import { BACKGROUND_COLOR } from "../styles/Theme";

export const HeroBackground = styled(Box)`
	background-image: url(${BackgroundImage});
	background-position: center;
	background-size: cover;
`;

export const ContentCenteredOnHeroBackground = styled(HeroBackground)`
	display: flex;
	justify-content: center;
	align-items: center;
	text-align: center;
	width: 100%;
`;

const CenteredContentOnSolidBackground = styled(Box)`
	background-color: ${BACKGROUND_COLOR};
	text-align: center;
	width: 100%;
`;

function ContentWrapperWithHeroBackground({ sx, ...props }: BoxProps) {
	const theme = useTheme();
	const isTabletOrMobile = useMediaQuery(theme.breakpoints.down("md"));

	if (isTabletOrMobile) {
		return (
			<CenteredContentOnSolidBackground {...props} sx={{ p: 2 }}>
				{props.children}
			</CenteredContentOnSolidBackground>
		);
	}

	return (
		<ContentCenteredOnHeroBackground>
			<Box
				{...props}
				sx={{
					bgcolor: BACKGROUND_COLOR,
					borderRadius: 2,
					minWidth: theme.breakpoints.values.md,
					maxWidth: theme.breakpoints.values.lg,
					width: "100%",
					m: 4,
					p: 2,
					...sx,
				}}
			>
				{props.children}
			</Box>
		</ContentCenteredOnHeroBackground>
	);
}

export default ContentWrapperWithHeroBackground;
